import { logo } from "helper/images";
import { useSelector } from "react-redux";
import { avatar } from "helper/images";
import { Link } from "react-router-dom";

export const Header = ({ rightComponent }) => {
  return (
    <div className="sticky top-0 h-20 bg-white lg:px-16 px-8 flex items-center justify-between z-10">
      <a href="https://www.k9scentgames.fun" target="_blank" rel="noopener noreferrer">
        <img src={logo} alt="" height={62} width={168} className="cursor-pointer" />
      </a>
      {rightComponent}
    </div>
  );
};

export const UserLoginHeader = () => {
  const { auth } = useSelector((state) => state);

  return (
    <div className="sticky top-0 h-20 bg-white  lg:pl-16 flex flex-row items-center justify-between">
      <a href="https://www.k9scentgames.fun" target="_blank" rel="noopener noreferrer">
        <img src={logo} alt="" className="sm:w-[168px] w-[100px] ml-4 cursor-pointer" />
      </a>
      <Link to="/dashboard/myProfile">
        <img
          height={62}
          width={168}
          src={auth?.memberReducer?.memberDetails?.profile ?? avatar}
          alt=""
          className="w-7 mb-3 mt-6 mr-10 rounded-[50px]"
        />
      </Link>
    </div>
  );
};
